<template>
  <div class="after_homework p-20">
    <div v-if="!showFinishHomework">
      <div class="paper_top flex Flexalign FlexBetween mb-20">
        <div class="exercise-title">· 考试</div>
        <div class="flex Flexalign cursor_pointer" @click="practiceBack">
          <el-image class="back_icon" :src="iconPath('back_icon.png')"></el-image>
          <div class="back_text">返回</div>
        </div>
      </div>
      <div class="homework_list">
        <div class="flex Flexalign btn_list">
          <div class="btn mr-15 cursor_pointer" v-for="(item, index) in btnList" :key="index"
            :class="btnStatus == item.status ? 'active_btn' : ''" @click="changeBtnStatus(item)">
            {{ item.label }}
          </div>
        </div>
        <div v-if="homeworList.length">
          <div class="homework_one flex Flexalign mt-20" v-for="(item, index) in homeworList" :key="index">
            <div class="hpmework_top_bg_box pl-12" v-if="item.homeworkType == 1">
              <div>测试卷</div>
            </div>
            <div class="hpmework_top_bg_box pl-12" v-if="item.homeworkType == 3">
              <div>自定义</div>
            </div>
            <!-- <el-image class="after_homework_cover" :src="iconPath('after_homework_cover.png')"></el-image> -->
            <div class="flex FlexBetween flexcolumn homework_info ml-15 flex-1 pb-15">
              <div class="flex Flexalign FlexBetween">
                <div class="homework_name">{{ item.testName }}</div>
                <div class="flex Flexalign">
                  <!-- <div>开放时间：{{ item.startTime.slice(0, -3) }}</div>
                  <div class="ml-20">结束时间：{{ item.endTime.slice(0, -3) }}</div> -->
                  <!-- 未开始：显示倒计时 -->
                  <div v-if="getExamStatus(item) === 'notStarted'" class="flex Flexalign">
                    <div>距开始时间</div>
                    <div class="countdown ml-10 mr-10">
                      {{ getCountdown(item) }}
                    </div>
                  </div>
                  <!-- 进行中：显示考试时间范围 -->
                  <div v-else-if="getExamStatus(item) === 'inProgress'" class="flex Flexalign">
                    <div>考试时间：{{ formatTimeRange(item.startTime, item.endTime) }}</div>
                  </div>
                  <!-- 已结束：显示考试时间范围 -->
                  <div v-else class="flex Flexalign">
                    <div>考试时间：{{ formatTimeRange(item.startTime, item.endTime) }}</div>
                  </div>
                </div>
              </div>
              <div class="flex Flexalign">
                <el-image class="total_score_icon" :src="iconPath('total_score_icon.png')"
                  v-if="item.fullScore"></el-image>
                <div class="total_score ml-5" v-if="item.fullScore">
                  总分{{ item.fullScore }}分
                </div>
                <div class="split_line mx-15" v-if="item.questionCount"></div>
                <el-image class="total_score_icon" :src="iconPath('total_num_icon.png')"
                  v-if="item.questionCount"></el-image>
                <div class="total_score ml-5" v-if="item.questionCount">
                  共{{ item.questionCount }}道题
                </div>
                <div class="split_line mx-15" v-if="item.answerTime"></div>
                <el-image class="total_score_icon" :src="iconPath('total_time_icon.png')"
                  v-if="item.answerTime"></el-image>
                <div class="total_score ml-5" v-if="item.answerTime">
                  考试时间{{ item.answerTime }}分钟
                </div>
              </div>
              <div class="flex Flexalign FlexBetween" style="width: 100%;">
                <div class="test_desc toverflow">{{ item.testDescription }}</div>
                <div class="btn_finish cursor_pointer" v-if="btnStatus == 1" @click="toFinish(item)">
                  开始考试
                </div>
                <div class="btn_finish cursor_pointer btn_detail" v-if="btnStatus == 2"
                  @click="goAfterHomeworkDetail(item)">
                  详情
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else>
          <moe-empty url="moe_empty_bg_img.png" emptyText="暂无考试"></moe-empty>
        </div>
      </div>
    </div>

    <myFinishHomework ref="myFinishHomework" @showHomework="showHomework" v-if="showFinishHomework"
      :examInfo="paperInfo" :homeworkType="'afterHomework'">
    </myFinishHomework>
  </div>
</template>

<script>
import { mapState } from "vuex";
import myFinishHomework from "./myFinishHomework.vue";
export default {
  name: "GjkcH5AfterHomework",

  components: { myFinishHomework },
  computed: {
    ...mapState({
      userInfo: (state) => state.userInfo,
      selectLearningInfo: (state) => state.learning.selectLearningInfo,
    }),
  },
  inject: ["showWrongQuestion", "showCustomizeHomework"],
  props: {
    courseDetail: {}
  },

  data() {
    return {
      homeworList: [],
      btnList: [
        { label: "待完成", status: 1 },
        // { label: "待批阅", status: 2 },
        { label: "已完成", status: 2 },
        // { label: "已过期", status: 3 },
      ],
      btnStatus: 1,
      showFinishHomework: false,
      listQuery: {
        chapterId: "",
        schemeId: "",
        roundId: "",
        examScenes: [3],
        phaseId: "",
      },
      countdownTimer: null,
      countdownMap: {} // 存储每个考试的倒计时
    };
  },

  mounted() {
    this.getAfterHomeworList();
    // 启动倒计时定时器
    this.startCountdownTimer();
  },
  beforeUnmount() {
    // 清理定时器
    this.stopCountdownTimer();
  },
  // 监听列表变化，重置倒计时
  watch: {
    homeworList: {
      handler() {
        this.countdownMap = {};
      },
      deep: true
    }
  },

  methods: {
    /**
     * 获取考试状态
     * @param {Object} item 考试项
     * @returns {String} 'notStarted' | 'inProgress' | 'ended'
     */
    getExamStatus(item) {
      const now = new Date().getTime();
      const startTime = new Date(item.startTime).getTime();
      const endTime = new Date(item.endTime).getTime();
      
      if (now < startTime) {
        return 'notStarted'; // 未开始
      } else if (now >= startTime && now <= endTime) {
        return 'inProgress'; // 进行中
      } else {
        return 'ended'; // 已结束
      }
    },
    
    /**
     * 获取倒计时文本
     * @param {Object} item 考试项
     * @returns {String} 倒计时文本
     */
    getCountdown(item) {
      const examId = item.examId || item.id; // 使用考试的唯一标识
      return this.countdownMap[examId] || this.calculateCountdown(item);
    },
    
    /**
     * 计算倒计时
     * @param {Object} item 考试项
     * @returns {String} 倒计时文本
     */
    calculateCountdown(item) {
      const now = new Date().getTime();
      const startTime = new Date(item.startTime).getTime();
      const diff = startTime - now;
      
      if (diff <= 0) {
        return '00:00:00';
      }
      
      return this.formatCountdown(diff);
    },
    
    /**
     * 格式化倒计时
     * @param {Number} milliseconds 毫秒数
     * @returns {String} 格式化后的倒计时
     */
    formatCountdown(milliseconds) {
      const totalSeconds = Math.floor(milliseconds / 1000);
      const days = Math.floor(totalSeconds / 86400);
      const hours = Math.floor((totalSeconds % 86400) / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;
      
      if (days > 0) {
        return `${days}天 ${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
      }
      return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
    },
    
    /**
     * 格式化时间范围
     * @param {String} startTime 开始时间
     * @param {String} endTime 结束时间
     * @returns {String} 格式化后的时间范围
     */
    formatTimeRange(startTime, endTime) {
      const start = this.formatTime(startTime);
      const end = this.formatTime(endTime);
      return `${start}~${end}`;
    },
    
    /**
     * 格式化单个时间
     * @param {String} time 时间字符串
     * @returns {String} 格式化后的时间
     */
    formatTime(time) {
      if (!time) return '';
      const date = new Date(time);
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      return `${month}-${day} ${hours}:${minutes}`;
    },
    
    /**
     * 启动倒计时定时器（每秒更新）
     */
    startCountdownTimer() {
      if (this.countdownTimer) {
        clearInterval(this.countdownTimer);
      }
      
      this.countdownTimer = setInterval(() => {
        let hasUpdate = false;
        
        this.homeworList.forEach(item => {
          if (this.getExamStatus(item) === 'notStarted') {
            const examId = item.examId || item.id;
            const newCountdown = this.calculateCountdown(item);
            
            // 检查倒计时是否变化
            if (this.countdownMap[examId] !== newCountdown) {
              this.countdownMap[examId] = newCountdown;
              hasUpdate = true;
            }
            
            // 如果倒计时结束，刷新列表
            const now = new Date().getTime();
            const startTime = new Date(item.startTime).getTime();
            if (now >= startTime) {
              this.getAfterHomeworList(); // 刷新列表
            }
          }
        });
        
        // 如果有变化，强制更新视图
        if (hasUpdate) {
          this.$forceUpdate();
        }
      }, 1000);
    },
    
    /**
     * 停止倒计时定时器
     */
    stopCountdownTimer() {
      if (this.countdownTimer) {
        clearInterval(this.countdownTimer);
        this.countdownTimer = null;
      }
    },
    
    /**
     * 获取考试列表（你原有的方法）
     */
    getAfterHomeworList() {
      this.$Api.exam
        .getExamList(this.btnStatus, this.courseDetail.courseId)
        .then((res) => {
          this.homeworList = res.data.data;
          // 重置倒计时映射
          this.countdownMap = {};
          // 强制更新
          this.$forceUpdate();
        })
        .catch(() => { });
    },
    practiceBack() {
      this.$emit("changeBacklogStep", 1);
    },
    // getAfterHomeworList() {
    //   this.$Api.exam
    //     .getExamList(this.btnStatus, this.courseDetail.courseId)
    //     .then((res) => {
    //       this.homeworList = res.data.data;
    //     })
    //     .catch(() => { });
    // },
    changeBtnStatus(info) {
      this.btnStatus = info.status;
      this.getAfterHomeworList();
    },
    // 去完成
    toFinish(info) {
      this.$store.commit("learning/setCurrentExamCourseId", this.courseDetail.courseId);
      this.href("/examStart", { paperInfo: JSON.stringify(info) })
      // this.showFinishHomework = true;
      // let stage = 1;
      // if (info.homeworkType == 3) {
      //   stage = 3;
      // }
      // setTimeout(() => {
      //   this.$refs.myFinishHomework.stage = stage;
      //   this.$refs.myFinishHomework.paperInfo = info;
      // }, 200);
    },
    // 重新提交
    resubmit(info) {
      this.showFinishHomework = true;
      setTimeout(() => {
        this.$refs.myFinishHomework.stage = 3;
        this.$refs.myFinishHomework.paperInfo = info;
      }, 200);
    },
    showHomework(flag) {
      this.freshKey++;
      this.showFinishHomework = flag;
      setTimeout(() => {
        if (this.$refs.myFinishHomework) {
          this.$refs.myFinishHomework.stage = 2;
        }
      }, 200);
      this.getAfterHomeworList();
    },
    getMyHomeworkList() {
      if (this.$Tools.empty(this.selectLearningInfo)) return;
      this.listQuery.chapterId = this.selectLearningInfo?.chapterId;
      this.listQuery.schemeId = this.selectLearningInfo?.schemeId;
      this.listQuery.roundId = this.selectLearningInfo?.roundId;
      this.listQuery.phaseId = this.selectLearningInfo?.id;
      this.$Api.course
        .getMyHomeworkList(this.listQuery)
        .then((res) => {
          this.consolidationList = res.data.data;
        })
        .catch(() => { });
    },
    // 详情
    goAfterHomeworkDetail(info) {
      this.$store.commit("learning/setCurrentExamCourseId", this.courseDetail.courseId);
      // 前往考试详情
      this.href("/examFinish", { recordId: info.recordId, courseId: this.courseDetail.courseId });
      // this.$Api.exam
      //   .getAfterHomeworkCustomRecord(info.recordId)
      //   .then((res) => {
      //     this.showCustomizeHomework(true, res.data.data, true);
      //   })
      //   .catch(() => { });
    },
  },
};
</script>

<style lang="scss" scoped>
.after_homework {
  width: 762px;
  background: #ffffff;
  border-radius: 10px;
  box-sizing: border-box;
  font-size: 14px;
  color: #111111;
  min-height: 880px;
  box-sizing: border-box;

  .paper_top {
    .empty {
      width: 1px;
      height: 1px;
    }

    .exercise-title {
      font-size: 18px;
      font-weight: 600;
    }

    .count_down {
      // width: 170px;
      height: 36px;
      background: linear-gradient(-42deg, #f45f0a 1%, #ed752f 100%);
      box-shadow: 0px 0px 9px 0px rgba(254, 121, 47, 0.53),
        0px 3px 3px 0px rgba(255, 255, 255, 0.23);
      border-radius: 10px;
      color: #ffffff;
      padding: 0 20px;
      line-height: 36px;
      margin-left: 60px;
    }

    .back_icon {
      width: 28px;
      height: 28px;
    }

    .back_text {
      font-size: 14px;
      color: #13d6aa;
      margin-left: 7px;
    }
  }

  .homework_list {
    .btn_list {
      .btn {
        font-size: 14px;
        color: #909090;
        width: 89px;
        height: 30px;
        border-radius: 23px;
        border: 1px solid #eaeaea;
        line-height: 30px;
        text-align: center;
      }

      .active_btn {
        background: linear-gradient(97deg, #00d498 0%, #00d5c2 100%);
        color: #ffffff;
      }
    }

    .homework_one {
      font-size: 14px;
      color: #909090;
      position: relative;

      .hpmework_top_bg_box {
        width: 51px;
        height: 22px;
        background: #ffbe01;
        border-radius: 12px 0px 12px 0px;
        font-size: 12px;
        color: #ffffff;
        position: absolute;
        top: -0;
        left: 0;
        z-index: 9;
      }

      .homework_name {
        font-size: 16px;
        color: #111111;
        font-weight: 600;
      }

      .after_homework_cover {
        width: 166px;
        height: 100px;
      }

      .total_score_icon {
        width: 16px;
        height: 16px;
      }

      .total_score {
        font-size: 12px;
      }

      .split_line {
        width: 1px;
        height: 14px;
        background-color: #b8b8b8;
      }

      .homework_info {
        width: 100%;
        height: 100px;
        border-bottom: 1px solid rgba(0, 0, 0, 0.1);
        min-width: 0;
      }

      .test_desc {
        width: 70%;
      }

      .btn_finish {
        width: 72px;
        height: 30px;
        background: linear-gradient(97deg, #00d498 0%, #00d5c2 100%);
        border-radius: 14px;
        text-align: center;
        line-height: 30px;
        color: #ffffff;
        margin-left: 50px;
      }

      .btn_readover {
        background: #ffb000;
        opacity: 0.36;
      }

      .btn_resubmit {
        border: 1px solid #13d6aa;
        background: none;
        color: #13d6aa;
      }

      .btn_detail {
        background: #357bfe;
      }
    }
  }
}
.countdown {
  font-size: 18px;
  font-weight: bold;
  color: #ff6619;
  background: #fff3e6;
  padding: 2px 8px;
  border-radius: 4px;
  font-family: monospace;
  min-width: 100px;
  text-align: center;
}
</style>
